import React from 'react';

type Props = {
  children: React.ReactNode;
};

// Web/default: no provider needed.
export default function BottomSheetProvider(props: Props) {
  return <>{props.children}</>;
}

